import { getAuthenticationHeader } from '@fenderdigital/custom-hooks/lib/cognito';

const KV_API_BASE_URL = `${process.env.REACT_APP_CLIENT_KV_API}/value`;

export const getValue = async (key: string): Promise<any> => {
  const url = `${KV_API_BASE_URL}/${key}`;
  const Authorization = await getAuthenticationHeader();
  const params = {
    method: 'GET',
    headers: {
      Authorization,
      Accept: 'application/json',
    },
  };

  const response = await fetch(url, params);
  return response.json();
};

interface Data {
  [key: string]: string;
}

export const setValue = async (data: Data): Promise<void> => {
  const Authorization = await getAuthenticationHeader();
  const params = {
    method: 'PUT',
    headers: {
      Authorization,
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  };
  await fetch(KV_API_BASE_URL, params);
};
